import { StandardTabsV2 } from '@cimplico/components';
import { useState } from 'react';
import { useWorkpaperContext } from '../../providers/WorkpaperProvider';

type NewOtherScheduleTabsProps = {
    onChange: (context: string) => void;
};

export default function NewOtherScheduleTabs({ onChange }: NewOtherScheduleTabsProps): JSX.Element {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const tabValues = ['current', 'prior'];
    const { priorWorkpaperId } = useWorkpaperContext();

    function handleTabChange(idx: number): void {
        setSelectedIndex(idx);
        const context = tabValues[idx];
        onChange(context);
    }

    return (
        <StandardTabsV2 name="context" onChange={handleTabChange} selectedIndex={selectedIndex}>
            <StandardTabsV2.Tab label={'Current Workpaper'} />
            <StandardTabsV2.Tab label={'Prior Workpaper'} isDisabled={!priorWorkpaperId} isDisabledHint="No prior workpaper linked" />
        </StandardTabsV2>
    );
}
